module.exports = __webpack_public_path__ + "static/media/heroimage_igib-007.373497c0.jpg";